module.exports = __webpack_public_path__ + "static/img/ASO_fr3.bbf7278.png";


//////////////////
// WEBPACK FOOTER
// ./src/page/img/ASO_fr3.png
// module id = Ob0C
// module chunks = 1